import { FormControl, FormGroup } from '@angular/forms';

/**
 * One treatment type auto-assignment may act on. An empty `treatmentSubTypeOriginalIds` means every sub
 * type of that type - by then the type is opted in by having an entry at all.
 */
export interface TreatmentAutoAssignScope {
    treatmentTypeOriginalId: number;
    treatmentSubTypeOriginalIds: number[];
}

export interface AppSettings {
    enableAutoDelivery: boolean;
    /** Master switch for shift-roster driven designer auto-assignment. */
    enableTreatmentAutoAssign: boolean;
    /**
     * Treatments created before this moment are never auto-assigned. Without it, enabling the feature
     * would make the sweeper act on the whole existing backlog of unassigned treatments.
     */
    treatmentAutoAssignFrom?: string | null;
    /**
     * Treatment types auto-assignment may act on. Empty means none - the scope is opt-in per type, so
     * the master switch on its own assigns nothing.
     */
    treatmentAutoAssignScopes: TreatmentAutoAssignScope[];
}

export const createAppSettingsForm = () =>
    new FormGroup({
        enableAutoDelivery: new FormControl({
            value: false,
            disabled: false,
        }),
        enableTreatmentAutoAssign: new FormControl({
            value: false,
            disabled: false,
        }),
        treatmentAutoAssignFrom: new FormControl<Date | string | null>({
            value: null,
            disabled: false,
        }),
        /**
         * The scope allow-list, edited as one set and replaced wholesale on save. Typed to admit null
         * because p-multiSelect's clear button writes null through its value accessor.
         */
        treatmentAutoAssignScopes: new FormControl<TreatmentAutoAssignScope[] | null>({
            value: [],
            disabled: false,
        }),
    });

export type AppSettingsForm = ReturnType<typeof createAppSettingsForm>;
export type AppSettingsInputModel = AppSettingsForm['value'];
